import { buildAdminMonitoringUrl } from "./adminMonitoringApi";

const SENSITIVE_KEYS = /password|token|authorization|secret|key|credential/i;

function sanitizeMetadata(value, depth = 0) {
  if (depth > 3 || value == null) {
    return value == null ? null : String(value);
  }
  if (Array.isArray(value)) {
    return value.slice(0, 20).map((item) => sanitizeMetadata(item, depth + 1));
  }
  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([key]) => !SENSITIVE_KEYS.test(key))
        .slice(0, 30)
        .map(([key, item]) => [key, sanitizeMetadata(item, depth + 1)])
    );
  }
  return typeof value === "string" ? value.slice(0, 500) : value;
}

export async function reportClientError({ message, stack, metadata } = {}) {
  if (!message || typeof navigator === "undefined") {
    return;
  }
  try {
    await fetch(buildAdminMonitoringUrl("/monitoring/client-errors"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: String(message).slice(0, 2000),
        stack: stack ? String(stack).slice(0, 4000) : null,
        screen: window.location?.pathname || "",
        app_version: process.env.REACT_APP_APP_VERSION || "1.2.0",
        platform: navigator.userAgent?.slice(0, 120) || "web",
        metadata: sanitizeMetadata(metadata || {}),
      }),
    });
  } catch (error) {
    // Monitoring must never break the app.
  }
}

export function installFrontendErrorCapture() {
  if (typeof window === "undefined") {
    return;
  }
  window.addEventListener("error", (event) => {
    reportClientError({
      message: event.message || "Unhandled frontend error",
      stack: event.error?.stack,
      metadata: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    reportClientError({
      message: reason?.message || String(reason || "Unhandled promise rejection"),
      stack: reason?.stack,
      metadata: { type: "unhandledrejection" },
    });
  });
}
